export default "__VITE_PUBLIC_ASSET__e2bbf489__"